
import Cookies from "universal-cookie";
import axios from "axios";
import Config from "../../config/index";
import { CREATE_ADMIN_REGISTRATION_FAILURE, CREATE_ADMIN_REGISTRATION_REQUEST, CREATE_ADMIN_REGISTRATION_SUCCESS } from "./adminRegistrationTypes";
let baseUrl = Config.baseUrl;
let serviceDeskId = Config.serviceDeskId;

const cookies = new Cookies();
const userData = cookies.get("loginDetailsForSupport");

  const createAdminRegistrationRequest = () => {
    return {
      type: CREATE_ADMIN_REGISTRATION_REQUEST,
    };
  };
  
  const createAdminRegistrationSuccess = (payload) => {
    return {
      type: CREATE_ADMIN_REGISTRATION_SUCCESS,
      payload: payload,
    };
  };
  
  const createAdminRegistrationFaliure = (error) => {
    return {
      type: CREATE_ADMIN_REGISTRATION_FAILURE,
      payload: error,
    };
  };
  
  const createAdminRegistration = (payload, token) => {
    return (dispatch) => {
      dispatch(createAdminRegistrationRequest());
      let url = `${baseUrl}/users_management/users/register_admin`;
      let config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      return axios
        .post(url, payload, config)
        .then((response) => {
          dispatch(createAdminRegistrationSuccess(response.data));
          return { status: true, data: response.data };
          })
          .catch((err) => {
          dispatch(createAdminRegistrationFaliure(err.response));
          return { status: false, message: err.response };
        });
    };
  };

  export {

    createAdminRegistration,

  };

  